<div class="home-page-container">
  <div class="block">

    <div id="dcx-landing">
      <div class="dcx-hero">
        <p class="dcx-h2">Already have a Group Online account?</p>
        <a href="{ name: 'Dashboard' }" class="dcx-button account-button" id="my-account">Log in &nbsp;<img src="@/assets/img/dot_lock.png" alt=""></a>
      </div>
      <div class="dcx-hero">
        <p class="dcx-h2">First time submitting a claim?</p>
      </div>
      <div class="dcx-columns">
        <div class="dcx-card col-xl-6 col-6 col-md-6 col-s-12 col-xs-12">
          <div class="dcx-card-header">
            <p>New to Group life & disability</p>
          </div>
          <div class="dcx-card-body">
            <p>
              For your first claim, you'll fill out some information then receive an email<br>to create your online profile.
            </p>
            <br>
            <p class="bold">What is Group life & disability insurance:</p>
            <br>
            <p>
              Helps you and your family recover financially after the loss of a loved one or a loss of income.
            </p>
            <ul>
              <li>Group life and accidental death and dismemberment (AD&D)</li>
              <li>Group disability</li>
              <li>Absence management</li>
            </ul>
            <br>
          </div>
          <footer class="dcx-card-footer">
            <a href="/claims/initiate/anon" class="button sya-button">Start a claim</a>
          </footer>
        </div>
        <div class="dcx-card col-xl-6 col-6 col-md-6 col-s-12 col-xs-12">
          <header class="dcx-card-header">
            <p>New to Select Benefits</p>
          </header>
          <div class="dcx-card-body">
            <p>
              You'll need to register for online access then log in to submit your first<br>claim.
            </p>
            <br>
            <p class="bold">What is Select Benefits voluntary insurance?</p>
            <br>
            <p>
              Helps you pay for out-of-pocket medical costs during recovery.
            </p>
            <ul>
              <li>Critical illness</li>
              <li>Accident</li>
              <li>Hospital indemnity</li>
              <li>GapAssist</li>
            </ul>
            <br>
          </div>
          <footer class="dcx-card-footer">
            <a :href="registrationUrl" class="button sya-button">Register for online access</a>
          </footer>
        </div>
      </div>

    </div>
  </div>
</div>
